"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: account/external-account-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Faccount%2Fexternal-account-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalAccountServiceClient = exports.RemoveExternalAccountResponse = exports.RemoveExternalAccountRequest = exports.UpdateExternalAccountResponse = exports.UpdateExternalAccountRequest = exports.GetExternalAccountsResponse = exports.GetExternalAccountsRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const external_account_1 = require("../common/external-account");
const protobufPackage = 'com.step.account.proto';
function createBaseGetExternalAccountsRequest() {
    return {};
}
exports.GetExternalAccountsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetExternalAccountsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetExternalAccountsRequest();
        return message;
    },
};
function createBaseGetExternalAccountsResponse() {
    return { accounts: [] };
}
exports.GetExternalAccountsResponse = {
    fromJSON(object) {
        const message = {
            accounts: globalThis.Array.isArray(object?.accounts)
                ? object.accounts.map((e) => external_account_1.ExternalAccount.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accounts?.length) {
            obj.accounts = message.accounts.map((e) => external_account_1.ExternalAccount.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetExternalAccountsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetExternalAccountsResponse();
        message.accounts = object.accounts?.map((e) => external_account_1.ExternalAccount.fromPartial(e)) || [];
        return message;
    },
};
function createBaseUpdateExternalAccountRequest() {
    return { externalAccountId: '', name: '' };
}
exports.UpdateExternalAccountRequest = {
    fromJSON(object) {
        const message = {
            externalAccountId: isSet(object.externalAccountId)
                ? globalThis.String(object.externalAccountId)
                : '',
            name: isSet(object.name) ? globalThis.String(object.name) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.externalAccountId !== '') {
            obj.externalAccountId = message.externalAccountId;
        }
        if (message.name !== '') {
            obj.name = message.name;
        }
        return obj;
    },
    create(base) {
        return exports.UpdateExternalAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateExternalAccountRequest();
        message.externalAccountId = object.externalAccountId ?? '';
        message.name = object.name ?? '';
        return message;
    },
};
function createBaseUpdateExternalAccountResponse() {
    return { externalAccount: external_account_1.ExternalAccount.fromPartial({}) };
}
exports.UpdateExternalAccountResponse = {
    fromJSON(object) {
        const message = {
            externalAccount: isSet(object.externalAccount)
                ? external_account_1.ExternalAccount.fromJSON(object.externalAccount)
                : external_account_1.ExternalAccount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.externalAccount !== undefined) {
            obj.externalAccount = external_account_1.ExternalAccount.toJSON(message.externalAccount);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateExternalAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateExternalAccountResponse();
        message.externalAccount =
            (object.externalAccount !== undefined && object.externalAccount !== null)
                ? external_account_1.ExternalAccount.fromPartial(object.externalAccount)
                : external_account_1.ExternalAccount.fromPartial({});
        return message;
    },
};
function createBaseRemoveExternalAccountRequest() {
    return { externalAccountId: '' };
}
exports.RemoveExternalAccountRequest = {
    fromJSON(object) {
        const message = {
            externalAccountId: isSet(object.externalAccountId)
                ? globalThis.String(object.externalAccountId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.externalAccountId !== '') {
            obj.externalAccountId = message.externalAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.RemoveExternalAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRemoveExternalAccountRequest();
        message.externalAccountId = object.externalAccountId ?? '';
        return message;
    },
};
function createBaseRemoveExternalAccountResponse() {
    return {};
}
exports.RemoveExternalAccountResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RemoveExternalAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRemoveExternalAccountResponse();
        return message;
    },
};
class ExternalAccountServiceClient {
    rpc;
    name = 'com.step.account.proto.ExternalAccountService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/account';
    methods = [{
            name: 'GetExternalAccounts',
            requestType: exports.GetExternalAccountsRequest,
            responseType: exports.GetExternalAccountsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UpdateExternalAccount',
            requestType: exports.UpdateExternalAccountRequest,
            responseType: exports.UpdateExternalAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'RemoveExternalAccount',
            requestType: exports.RemoveExternalAccountRequest,
            responseType: exports.RemoveExternalAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Returns all of the user's external accounts.
     */
    getExternalAccounts(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Updates an existing external account.
     */
    updateExternalAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Removes an external account.
     */
    removeExternalAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.ExternalAccountServiceClient = ExternalAccountServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=external-account-service.js.map